// extracted by mini-css-extract-plugin
module.exports = {"searchErrors":"searchMessage_searchErrors__o4uNp","searchDescription":"searchMessage_searchDescription__h5Vro"};